module.exports = __webpack_public_path__ + "img/5-5.9ca58966.svg";